// Capture & persist UTM/click params for the entire session.
// First-touch attribution: stored once, reused across refreshes & navigations.
const KEY = "madeira_attribution_v1";
const FIELDS = [
  "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content",
  "gclid", "fbclid",
];

export function captureAttribution() {
  if (typeof window === "undefined") return {};
  try {
    const stored = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (stored) return stored;

    const params = new URLSearchParams(window.location.search);
    const data = {};
    FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v) data[f] = v;
    });
    data.referrer = document.referrer || "";
    data.landing_page = window.location.href;
    sessionStorage.setItem(KEY, JSON.stringify(data));
    return data;
  } catch {
    return {};
  }
}

export function getAttribution() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}
